import React from "react";

const TodayProgress = ({ displayDate, totalProtein, proteinPercentage }) => {
  return (
    <div className="today-progress tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-white  dark:tw-bg-black tw-rounded-2xl tw-shadow-sm tw-p-8 tw-text-center">
      <div className="tw-flex tw-justify-between tw-items-center tw-w-full tw-mb-4">
        <h2 className="tw-font-semibold dark:tw-text-white">Tracker</h2>
        <span className="tw-text-gray-500">{displayDate}</span>
      </div>
      <div className="tw-relative tw-w-[200px] tw-h-[200px]">
        <svg
          className="tw-absolute tw-top-0 tw-left-0 tw-rotate-90"
          width="200"
          height="200"
        >
          <circle
            cx="100"
            cy="100"
            r="90"
            stroke="#E5E7EB"
            strokeWidth="20"
            fill="none"
          />
          <circle
            cx="100"
            cy="100"
            r="90"
            stroke="#22c55e"
            strokeWidth="20"
            fill="none"
            strokeDasharray={`${
              (proteinPercentage * (2 * Math.PI * 90)) / 100
            }, ${2 * Math.PI * 90}`}
            strokeLinecap="round"
          />
        </svg>
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-absolute tw-top-0 tw-right-0 tw-left-0 tw-mx-auto">
          <p className="tw-text-3xl dark:tw-text-white">
            {totalProtein.toFixed(0)}
            <span className="tw-text-base">g</span>
          </p>
          <p className="tw-text-gray-600"> protein</p>
        </div>
      </div>
    </div>
  );
};

export default TodayProgress;
